import { useQuery } from 'react-query'
import { useRef } from 'react'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import ApiClient from '../lib/api-client'
import { formatDuration } from '../lib/format-date'
const CONFIG_TYPE = 'HOSTED_EXB'

export function getConfig (configType, configQuery) {
  const config = configQuery.data?.configs
    .find(x => x.configType === configType)
  return config
}

export function isFeatureEnabled (featureName, configQuery) {
  const config = getConfig('ENABLED_FEATURES', configQuery)
  const enabledFeatures = config?.data?.features ?? []
  return enabledFeatures.includes(featureName)
}

export function isAllowFeatureDataEnrichment (configQuery) {
  const fdeConfig = getConfig('FEATURE_DATA_ENRICHMENT', configQuery)
  return fdeConfig?.data?.enabled === true
}

export function getMapViewerConfig (configQuery) {
  const config = getConfig('MAP_VIEWER', configQuery)
  return config?.data || { value: 'classic' }
}

export function useHostedExbInfo ({ tenantId, role, refetchInterval = (1000 * 30), refetchIntervalInBackground = true }) {
  const { t } = useTranslation()
  const isTriggered = useRef(false)
  return useTenantConfigs(tenantId, CONFIG_TYPE, {
    refetchInterval,
    refetchIntervalInBackground,
    onSuccess: (resp) => {
      const currentInfo = resp?.configs ? resp?.configs.find(x => x.configType === CONFIG_TYPE) : {}
      if (refetchIntervalInBackground) {
        const date = currentInfo?.data?.startedAt
        const endTime = dayjs(date).add(2, 'h')
        const diff = dayjs(endTime).diff(new Date(), 'm')
        // only trigger once when the session is remain 15 minutes
        if (diff === 15 && !isTriggered.current) {
          const data = {
            detail: {
              action: 'show',
              type: 'info',
              title: t('hostedExbService_title'),
              message: t('hostedExbService_statusMessage', { duration: formatDuration(date) }),
              dismissAfter: 1000 * 60 * 5
            }
          }
          const event = new CustomEvent('flash', data)
          document.dispatchEvent(event)
          isTriggered.current = true
        }
      }
    },
    enabled: Boolean(tenantId) && role !== 'SYSADMIN'
  })
}

function useTenantConfigs (tenantId, configType, options = {}) {
  let url = `/system/tenants/${tenantId}/configs`
  if (configType) {
    url = `${url}?configType=${configType}`
  }
  return useQuery(
    ['tenant', 'configs', { tenantId, configType }],
    () => ApiClient.get(url).then(data => data),
    Object.assign({
      enabled: Boolean(tenantId)
    },
    options
    )
  )
}

export default useTenantConfigs
